var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 112,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.398 29.827V.096H48.186V109.85h35.327V29.827h33.885Z",
    fill: "#5448EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m179.264 78.446 21.555 31.405h39.473l-26.451-35.483c16.739-11.229 20.58-23.714 20.58-34.48 0-7.513-1.802-14.262-5.407-20.249-3.605-6.103-8.952-10.857-16.041-14.261-7.09-3.521-15.741-5.282-25.955-5.282h-55.694V109.85h35.327V78.446h12.613Zm4.87-23.593h-17.483V28.97h17.483c4.686 0 8.231 1.174 10.634 3.521 2.524 2.23 3.785 5.341 3.785 9.332 0 4.226-1.201 7.454-3.604 9.684-2.404 2.23-6.008 3.345-10.815 3.345Z",
    fill: "#5448EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.559.096v57.639c0 6.69 1.562 11.855 4.686 15.494 3.244 3.638 8.111 5.458 14.6 5.458 6.488 0 11.355-1.82 14.599-5.458 3.364-3.757 5.047-8.921 5.047-15.494V.095h35.327v57.64c0 11.385-2.464 21.128-7.39 29.227-4.927 7.982-11.656 14.027-20.187 18.135-8.411 3.991-17.784 5.986-28.117 5.986-10.334 0-19.586-1.995-27.757-5.986-8.051-4.108-14.42-10.153-19.106-18.135-4.566-7.982-6.849-17.724-6.849-29.227V.095h35.147ZM469.976 29.827V.096H367.239v29.73h33.525v80.025h35.327V29.827h33.885ZM594.57.096V109.85h-35.327v-38.33h-43.077v38.33h-35.327V.096h35.327v41.519h43.077V.095h35.327ZM.959.096h33.913V29.82H.96V.096Z",
    fill: "#5448EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M640.667 80.484H606.7v29.437h33.967V80.483Z",
    fill: "#2DD0B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruth);
export default __webpack_public_path__ + "static/media/truth.89eb008bc97789bb4d2e2dd54408363d.svg";
export { ForwardRef as ReactComponent };